import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

/** Render *marked* words as italic rose spans (used in CMS-editable headings). */
export function Em({ text, emClass = "font-light italic text-rose" }) {
  return String(text ?? "")
    .split("*")
    .map((part, i) =>
      i % 2 === 1 ? (
        <em key={i} className={emClass}>
          {part}
        </em>
      ) : (
        <span key={i}>{part}</span>
      ),
    );
}

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function ChapterHeading({ number, kicker, title, blurb, dark = false }) {
  return (
    <Reveal className="mb-14 flex flex-col gap-6 md:mb-20 md:flex-row md:items-end md:justify-between">
      <div>
        <p
          data-testid={`chapter-kicker-${number}`}
          className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-rose md:text-sm"
        >
          {number} — {kicker}
        </p>
        <h2
          className={`font-serif text-4xl font-medium tracking-tight md:text-6xl ${
            dark ? "text-cream" : "text-ink"
          }`}
        >
          {title}
        </h2>
      </div>
      {blurb && (
        <p
          className={`max-w-sm text-sm leading-relaxed md:text-base ${
            dark ? "text-white/60" : "text-[#5C5C5C]"
          }`}
        >
          {blurb}
        </p>
      )}
    </Reveal>
  );
}
